import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  TwoFactorConfigurationService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AppServices__2FA_TwoFactorConfigurationResponseDto,
} from '../../services/wealthlane-identity-services';

const usePostEnableTwoFactor = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  onSuccess?: (
    // eslint-disable-next-line camelcase
    response: Wealthlane_AppServices__2FA_TwoFactorConfigurationResponseDto | undefined
  ) => void
): UseMutationResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AppServices__2FA_TwoFactorConfigurationResponseDto | undefined,
  unknown,
  number,
  unknown
> => {
  const queryClient = useQueryClient();

  return useMutation(
    async (optionId: number) => {
      return await handleRequest(
        TwoFactorConfigurationService.postApiIdentityApiTwoFactorConfigurationEnableTwoFactor(
          optionId
        )
      );
    },
    {
      onSuccess: async (response) => {
        if (response != null) {
          window.sessionStorage.removeItem('OtpToken');
          toast.success(
            <ToastComponent label='Success' message='Two-factor authentication enabled.' />
          );
          await queryClient.invalidateQueries('getIsTwoFactorEnabled');
          onSuccess && onSuccess(response);
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostEnableTwoFactor;
